import React from 'react';

import { Helmet } from 'react-helmet';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Container } from '@mui/material';

import Asinc from '~/components/Common/Asinc';

import { healthCheck } from '~/services/PaymentsService';
import UsersService from '~/services/UsersService';

import PageHeader from '../Common/Elements/PageHeader';

const ORDERS_GUI_HOST = `${window.configs.API_HOST}/jobs/orders`;

function renderServiceHealth(promiseResults) {
  const result = promiseResults?.result ?? {};

  return (
    <div>
      <p>Service has both redis and postgres connectivity</p>
      <p>Worker Backlog: {result.queue_backlog ?? 'Unavailable'}</p>
      <p>Worker Processing: {result.queue_processing ?? 'Unavailable'}</p>
    </div>
  );
}

export default function HealthPage() {
  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Services Statuses</title>
      </Helmet>

      <PageHeader title="Service statuses" />

      <Accordion variant="outlined">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Payment service</AccordionSummary>
        <AccordionDetails>
          <Asinc promise={healthCheck()} then={renderServiceHealth} />
        </AccordionDetails>
      </Accordion>

      <Accordion variant="outlined">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Auth service</AccordionSummary>
        <AccordionDetails>
          <Asinc promise={UsersService.healthCheck()} then={renderServiceHealth} />
        </AccordionDetails>
      </Accordion>

      <Accordion variant="outlined">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Order service</AccordionSummary>
        <AccordionDetails>
          <iframe className="order-job-frame" src={ORDERS_GUI_HOST} />
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}
